import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SendHorizonal } from 'lucide-react';

export default function ChatInput({ onSend, disabled }) {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 160) + 'px';
  }, [value]);

  const submit = () => {
    const text = value.trim();
    if (!text || disabled) return;
    onSend(text);
    setValue('');
  };

  return (
    <div className="border-t border-gray-200 p-2 flex items-end gap-2">
      <textarea
        ref={ref}
        rows={1}
        value={value}
        disabled={disabled}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
        placeholder={t('chatbot.placeholder', 'Posez votre question...')}
        className="flex-1 resize-none rounded-md border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50 max-h-40"
      />
      <button
        onClick={submit}
        disabled={disabled || !value.trim()}
        className="p-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label={t('chatbot.send', 'Envoyer')}
      >
        <SendHorizonal size={16} />
      </button>
    </div>
  );
}
